import React from 'react'

import clsx from 'clsx'

import Card from 'components/Card'
import Grid from 'components/Grid'

import TextBase from '../TextBase'
import FeatureHighlighted from './components/FeatureHighlighted'

import classes from './Options.module.scss'

/** @type {import("./types").default} */
const Options = ({ title, subtitle, htmlText, options, className }) => {
  return (
    <section className={clsx('Options', classes.root, className)}>
      {title && <TextBase title={title} />}
      <TextBase subtitle={subtitle} />
      <Grid container>
        <Grid item xs={12} lg={7} className={classes.text}>
          <TextBase htmlText={htmlText} />
        </Grid>
        <Grid item xs={12} lg={5}>
          <Card className={classes.card} elevation={0}>
            {options.map(name => (
              <FeatureHighlighted key={`feature-${name}`} checked={true} data-testid="feature-check">
                {name}
              </FeatureHighlighted>
            ))}
          </Card>
        </Grid>
      </Grid>
    </section>
  )
}

export default Options
